"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerContext = void 0;
// This is file should mirror https://github.com/react-navigation/react-navigation/blob/6.x/packages/native/src/ServerContext.tsx
const react_1 = require("react");
exports.ServerContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=serverLocationContext.js.map